'use client';

import { useEffect, useState } from 'react';

import { useRouter } from 'next/navigation';

import type { LoginRes } from '@quick/go-api-types/users/v2/login';

import { useLangProvider } from '@/components/core/AppLayout';
import { LoginComponent } from '@/components/core/Login';
import { useUser } from '@/layers/core/deal/services/useUser';

export default function UserLogin() {
  const twoFactor = useState<Omit<LoginRes, 'two_factor'> | null>(null);
  useRedirectUserIfLoggedIn();

  return (
    <div
      className="relative flex h-full min-h-screen w-full items-center justify-center px-5
        sm:px-0 dark:bg-gray-700"
    >
      <LoginComponent twoFactor={twoFactor} className="" />
    </div>
  );
}

function useRedirectUserIfLoggedIn() {
  const router = useRouter();
  const lang = useLangProvider();
  const { token } = useUser();

  useEffect(() => {
    if (!router) return;
    if (!token) return;
    const search = new URLSearchParams(document.location.search);
    const next = search.get('next');
    const pathname =
      next?.toString().replace('/[lang]', `/${lang}`) ?? `/${lang}/platform`;

    search.delete('next');
    const query = search.size > 0 ? `?${search.toString()}` : '';
    router.push(`${pathname}${query}`);
  }, [token, lang, router]);
}
